export default "__VITE_ASSET__4bf78c67__"